import Vue from 'vue'
import VueLazyLoad from 'vue-lazyload'
const loadimage = require('../assets/image/global/loading.gif')
Vue.use(VueLazyLoad, {
  preLoad: 1.2, // 预加载的宽高比，4:3
  attempt: 1 ,//尝试加载次数
  // loading: loadimage, //加载时图像的src
})